import {
  DisplayLangResource,
  DisplayLanguage
} from '../types/game-document/entities/display-languages';

export const DisplayLangResources: DisplayLangResource[] = [
  {
    //game display language part
    displayId: '001',
    id: 'f7c9251f-9bba-47c8-a554-7ddc95cd0dd4',
    value: 'Preload Assets',
    type: 'text'
  },
  {
    displayId: '002',
    id: 'd705595a-5864-4eb7-aa72-af7b2f2bb19e',
    type: 'text',
    value: 'It will take a few seconds'
  },
  {
    displayId: '003',
    id: '5d7d9dae-f5d4-45ba-993d-22fa61ca16e5',
    type: 'text',
    value: '% Total assets'
  },
  {
    displayId: '004',
    id: '079c039a-8207-4404-8eb6-558cf5d8477b',
    type: 'text',
    value: 'Next'
  },
  {
    displayId: '005',
    id: 'd594b340-e6db-4822-9dfa-6701afbd5677',
    value: 'Language',
    type: 'text'
  },
  {
    displayId: '006',
    id: 'bb8f780c-fbd9-48d5-a725-3efb8dcba95c',
    value: 'Select language',
    type: 'text'
  },
  {
    displayId: '008',
    id: '00100845-d632-4d60-9140-46dddb187781',
    value: 'Your player name',
    type: 'text'
  },
  {
    displayId: '009',
    id: '3cf798f7-da4d-47b4-a3d2-713191b0d3cc',
    value:
      'Now, give yourself a fun player name. it doesn\u0027t have to be your real name',
    type: 'text'
  },
  {
    displayId: '010',
    id: 'ff5ffdc0-5b2d-4b40-a1b0-66f3c886df89',
    value: 'Player Name',
    type: 'text'
  },
  {
    displayId: '011',
    id: 'ab253e81-5612-4cc8-93b3-56cb2e3a056b',
    value: 'Your avatar',
    type: 'text'
  },
  {
    displayId: '012',
    id: '4e040b03-759f-49e3-b48a-7d0c0a1914e9',
    value: 'Upload an image of your choice',
    type: 'text'
  },
  {
    displayId: '013',
    id: '750604c5-d26a-4dfb-9db1-25eda7a6d95f',
    value: 'Or choose an avatar from our library',
    type: 'text'
  },
  {
    displayId: '014',
    id: '5f243f13-e05b-448b-8a19-b45e16f9719c',
    value: 'Finish',
    type: 'text'
  },
  {
    displayId: '015',
    id: '670d9f08-d761-4c71-883c-4265648d6a73',
    value: 'Info',
    type: 'text'
  },
  {
    displayId: '016',
    id: '4be208b6-39fc-434d-bae7-e39f6d1ed332',
    value: 'Teams',
    type: 'text'
  },
  {
    displayId: '017',
    id: 'f7a7c135-91e2-433f-a7ed-0b62ff39aba0',
    value: 'Inventory',
    type: 'text'
  },
  {
    displayId: '018',
    id: '832f9ead-d125-4418-aebb-ebdff00a3a8d',
    value: 'Roles',
    type: 'text'
  },
  {
    displayId: '019',
    id: '57f9b876-0dcf-4e59-b240-2dc88aa9390e',
    value: 'Chat',
    type: 'text'
  },
  {
    displayId: '020',
    id: 'e698200c-73e4-41e3-b4b1-fa4b38f4638c',
    value: 'Leaderboard',
    type: 'text'
  },
  {
    displayId: '023',
    id: 'e4d66a9d-ed75-443e-82f1-9a8da53325d8',
    value: 'Enter Game',
    type: 'text'
  },
  {
    displayId: '024',
    id: '848ee4b0-e2ce-4974-a17c-d53bf10f6719',
    value: 'Create new team',
    type: 'text'
  },
  {
    displayId: '025',
    id: '5bc0109c-91f4-473e-94e1-99444faeaabf',
    value: 'Team name',
    type: 'text'
  },
  {
    displayId: '026',
    id: '6db126df-9980-4fed-b80a-1d7a29dbb662',
    value: 'Save',
    type: 'text'
  },
  {
    displayId: '030',
    id: 'f932f99f-2e5f-4b02-9977-ba9a58764a8e',
    value: 'Player titles',
    type: 'text'
  },
  {
    displayId: '031',
    id: '5c5b9991-689f-459d-99b9-0453d313f8c9',
    value: 'Team titles',
    type: 'text'
  },
  {
    displayId: '032',
    id: 'cf3a5e89-6556-4671-9593-0f930e29c58d',
    value: 'Available titles',
    type: 'text'
  },
  {
    displayId: '033',
    id: 'e20069a1-1a00-4183-b62e-7375d02b4721',
    value: 'Chat with',
    type: 'text'
  },
  {
    displayId: '034',
    id: 'bd2f061c-b665-4fe5-84ce-b986a1008a76',
    value: 'All players',
    type: 'text'
  },
  {
    displayId: '035',
    id: '6a6f31b6-fb91-42f8-acab-f469e0ef1d86',
    value: 'My team',
    type: 'text'
  },
  {
    displayId: '036',
    id: '8fd3fb0f-e237-4717-9272-98a84f4e9af4',
    value: 'My group',
    type: 'text'
  },
  {
    displayId: '037',
    id: 'fe72a8db-b666-4720-b08c-6081605cd24c',
    value: 'Facilitators',
    type: 'text'
  },
  {
    displayId: '038',
    id: '2373ccd3-e73e-403d-bd99-7083f1512a96',
    value: 'Type a message...',
    type: 'text'
  },
  {
    displayId: '039',
    id: '6560df9f-604b-4430-83f4-7b61575e25ba',
    value: 'Score',
    type: 'text'
  },
  {
    displayId: '042',
    id: '5163981d-0d89-4afb-b0d8-f2d0e42de142',
    value: 'Cancel',
    type: 'text'
  },
  {
    displayId: '044',
    id: 'f27a1675-58e4-4e01-93a0-f6a830eba04f',
    value: 'The game has ended',
    type: 'text'
  },
  {
    displayId: '045',
    id: '6e07cb7a-3a2c-484f-9824-15d1db9629d0',
    value: 'You can still access the main menu and chat.',
    type: 'text'
  },
  {
    displayId: '046',
    id: '66883910-7d5d-4858-8ca0-f433072cc57e',
    value: 'Join team',
    type: 'text'
  },
  {
    displayId: '047',
    id: '983f048a-ec82-47fd-9f7e-c59ab3526d5a',
    value: 'Leave team',
    type: 'text'
  },
  {
    displayId: '048',
    id: '49aee67e-8bc4-4680-98f4-03d4636bcc73',
    value: 'Team member',
    type: 'text'
  },
  {
    displayId: '049',
    id: '82f09d89-f2e6-4ec2-ac6a-644b40d503bf',
    value: 'Name',
    type: 'text'
  },
  {
    displayId: '050',
    id: '42b77164-cdf8-4222-94ad-4e5652b6b2f8',
    value: 'No photo submitted. Please try again.',
    type: 'text'
  },
  {
    displayId: '051',
    id: '4981eed4-5e4a-4f90-819e-385c7634a48e',
    value: 'No video submitted. Please try again.',
    type: 'text'
  },
  {
    id: 'be998642-6834-40d7-b457-55acafbe0fc0',
    value: 'Continue',
    type: 'text'
  },
  {
    id: '48bc820b-40e8-4624-8d46-b68e16013be6',
    value: 'Close',
    type: 'text'
  },
  {
    id: '8065dbef-51c3-4e7b-82e8-48ea0bfdf093',
    value: 'Submit',
    type: 'text'
  },
  {
    id: '80884474-f011-402e-b4ea-6aa791457ed9',
    value: 'Correct',
    type: 'text'
  },
  {
    id: '3a0d67d6-8374-43ae-a050-2c256a3bece4',
    value: 'Incorrect',
    type: 'text'
  },
  {
    id: '326560e1-3c4b-4e0b-a31e-8fecfc533fd7',
    value: 'Answer submitted',
    type: 'text'
  },
  {
    id: '567963b7-47c0-40e9-8659-2e43a5a5befb',
    value: 'Preview',
    type: 'text'
  },
  {
    id: 'b6d7d97b-37bd-4ef9-aa9e-0e02a404a375',
    value: 'Add from files',
    type: 'text'
  },
  {
    id: '51689c93-1e57-4c72-9308-5deab301614a',
    value: 'Take from camera',
    type: 'text'
  },
  {
    id: '59473aee-f6c3-4657-aa6e-f72a9726e4dc',
    value: 'Turn off camera',
    type: 'text'
  },
  {
    id: '7b63892e-236c-4b6a-bfec-d5d3d66794af',
    value: 'Take picture',
    type: 'text'
  },
  {
    id: '71a2dffb-7ae7-422f-8423-93b0d4f15a4a',
    value: 'Uploading...',
    type: 'text'
  },
  {
    id: '3d6b40c6-d321-441b-8b8b-5982da856e9a',
    value: 'Recording...',
    type: 'text'
  },
  {
    id: 'e1527e98-9fba-4a13-b082-7c510d10a4e0',
    value: 'Submit video',
    type: 'text'
  },
  {
    id: '9ff35578-4946-4900-a4a3-e76f776ab4ca',
    value: 'Invalid File Type: Please upload video files only.',
    type: 'text'
  },
  {
    id: '4af50ef9-db25-48cf-9fa2-2a5ad295d6cf',
    value: 'Invalid File Type: Please upload image files only.',
    type: 'text'
  },
  {
    id: 'cea1d18b-4808-4c1f-8d46-88edf44ba525',
    value: 'points awarded for your correct answer!',
    type: 'text'
  },
  {
    id: '32681cc9-9ee0-4d19-81fa-7a2b6e69a362',
    value: 'Your answer has been submitted to the Facilitator for review',
    type: 'text'
  },
  {
    id: '88a6f4c3-09f5-4a93-89de-62f1d6c13938',
    value: "Congratulations. You've been awarded % points.",
    type: 'text'
  },
  {
    id: 'c0acec61-3782-4e51-bac5-3cfa930c2586',
    value: 'Re-submit',
    type: 'text'
  },
  {
    id: '298f372e-f97b-42c6-b1a7-a0bf7866ec7b',
    value: 'Try again - % attempt(s) remaining',
    type: 'text'
  },
  {
    id: '0c38ed7b-a7b0-4091-bc8b-af7271652d2e',
    value: 'This is a team game. You must be part of a team to join the game',
    type: 'text'
  },
  {
    id: 'fb5a1ca5-069e-4dda-aa26-a414100396da',
    value: 'Select a team',
    type: 'text'
  },
  {
    id: '3a7b6b1a-8c9e-4d5f-9a1b-2c3d4e5f6a7b',
    value: 'Point',
    type: 'text'
  },
  {
    id: '4b8c7c2b-9d0f-5e60-ab2c-3d4e5f6a7b8c',
    value: 'Points',
    type: 'text'
  },
  {
    id: '5c9d8d3c-0e10-6f71-bc3d-4e5f6a7b8c9d',
    value: 'Excellent!',
    type: 'text'
  },
  {
    id: '6d0e9e4d-1f11-7082-cd4e-5f6a7b8c9d0e',
    value: 'Unlucky.',
    type: 'text'
  },
  {
    id: '47750496-640c-46c5-945c-0a72fcc7a259',
    value: 'On-demand tasks',
    type: 'text'
  },
  {
    id: '7e1f2e3d-4c5b-6a7e-8f9d-0a1b2c3d4e5f',
    value: 'points available',
    type: 'text'
  },
  {
    id: '8f2a3b4c-5d6e-7f8a-9b0c-1d2e3f4a5b6c',
    value: 'Complete these tasks at any time for additional points.',
    type: 'text'
  },
  {
    id: '9a3b4c5d-6e7f-8a9b-0c1d-2e3f4a5b6c7d',
    value: 'Search roles',
    type: 'text'
  },
  {
    id: 'c6d7e8f9-0a1b-2c3d-4e5f-6a7b8c9d0e1f',
    value: 'Out of stock',
    type: 'text'
  },
  {
    id: 'd7e8f90a-1b2c-3d4e-5f6a-7b8c9d0e1f2a',
    value: 'Acquire',
    type: 'text'
  },
  {
    id: 'e8f90a1b-2c3d-4e5f-6a7b-8c9d0e1f2a3b',
    value: 'Return',
    type: 'text'
  },
  {
    id: 'f90a1b2c-3d4e-5f6a-7b8c-9d0e1f2a3b4c',
    value: 'Your Inventory',
    type: 'text'
  },
  {
    id: 'a1b2c3d4-e5f6-a7b8-c9d0-e1f2a3b4c5d6',
    value: 'Team Inventory',
    type: 'text'
  },
  {
    id: 'b2c3d4e5-f6a7-b8c9-d0e1-f2a3b4c5d6e7',
    value: 'Trading with',
    type: 'text'
  },
  {
    id: '3bbdfe90-6454-4833-8b93-1a94f631e406',
    value: 'On going trading with',
    type: 'text'
  },
  {
    id: 'c3d4e5f6-a7b8-c9d0-e1f2-a3b4c5d6e7f8',
    value: 'Your offer',
    type: 'text'
  },
  {
    id: 'd4e5f6a7-b8c9-d0e1-f2a3-b4c5d6e7f8a9',
    value: 'Make offer',
    type: 'text'
  },
  {
    id: 'e5f6a7b8-c9d0-e1f2-a3b4-c5d6e7f8a9b0',
    value: 'Counter offer',
    type: 'text'
  },
  {
    id: 'f6a7b8c9-d0e1-f2a3-b4c5-d6e7f8a9b0c1',
    value: 'Tap to remove',
    type: 'text'
  },
  {
    id: '0a1b2c3d-4e5f-6a7b-8c9d-0e1f2a3b4c5d',
    value: 'Draft',
    type: 'text'
  },
  {
    id: '1b2c3d4e-5f6a-7b8c-9d0e-1f2a3b4c5d6e',
    value: 'Pending',
    type: 'text'
  },
  {
    id: '2c3d4e5f-6a7b-8c9d-0e1f-2a3b4c5d6e7f',
    value: 'Accept trade',
    type: 'text'
  },
  {
    id: '3d4e5f6a-7b8c-9d0e-1f2a-3b4c5d6e7f8a',
    value: 'Cancel trading',
    type: 'text'
  },
  {
    id: '4e5f6a7b-8c9d-0e1f-2a3b-4c5d6e7f8a9b',
    value: 'Send message',
    type: 'text'
  },
  {
    id: '5f6a7b8c-9d0e-1f2a-3b4c-5d6e7f8a9b0c',
    value: 'Trading screen',
    type: 'text'
  },
  {
    id: '6a7b8c9d-0e1f-2a3b-4c5d-6e7f8a9b0c1d',
    value: 'Partially correct',
    type: 'text'
  },
  //game display language part end
  //feedback display language part
  {
    displayId: 'fb-1',
    id: '3ed6fe99-9545-44b2-9800-52495d998967',
    value: 'Name',
    type: 'text'
  },
  {
    displayId: 'fb-2',
    id: '8f2695c9-3074-48bf-b68a-76d5beaffa44',
    value: 'Anonymous',
    type: 'text'
  },
  {
    displayId: 'fb-3',
    id: 'd9e11c05-454f-44c0-bbc9-5de7dedf8f69',
    value: 'Your Games',
    type: 'text'
  },
  {
    displayId: 'fb-4',
    id: '84bccd9b-ed5d-4daa-b564-1aeb96c0929a',
    value: 'Continue',
    type: 'text'
  },
  {
    displayId: 'fb-5',
    id: '5463fd5e-5a92-4e61-9cd7-162fb43668fe',
    value: 'Question',
    type: 'text'
  },
  {
    displayId: 'fb-6',
    id: '9218c923-0be1-47f8-ae56-565694b5de33',
    value: 'Type your answer here…',
    type: 'text'
  },
  {
    displayId: 'fb-7',
    id: '03e6aadb-3a09-4d5e-a27a-dac966707a0f',
    value: 'Skip',
    type: 'text'
  },
  {
    displayId: 'fb-8',
    id: '9a5c9d53-6aae-4be4-b556-213fee60eeb7',
    value: 'Submit Answer',
    type: 'text'
  },
  {
    displayId: 'fb-9',
    id: '7a4ce6eb-62e6-4ac4-a53f-2df466858a52',
    value: 'Thank you for your time',
    type: 'text'
  },
  {
    displayId: 'fb-10',
    id: '05635089-36d4-4205-967f-8d60e7311ca9',
    value:
      'We value your feedback. The survey is complete. You can now close this page.',
    type: 'text'
  },
  {
    displayId: 'fb-11',
    id: '77284806-5846-4da9-a92f-1aee27ad6943',
    value: 'Please select the activity to provide feedback on.',
    type: 'text'
  },
  {
    displayId: 'fb-12',
    id: '714c5007-ce05-477e-8dc2-8f9502eb4c45',
    value: 'Previous',
    type: 'text'
  },
  {
    displayId: 'fb-13',
    id: '6101dd6b-0e30-4518-b9d9-37a4173c1031',
    value: 'Next',
    type: 'text'
  }
  //feedback display language part end
];

export const DefaultDisplayLanguage: DisplayLanguage = {
  id: '00000000-0000-0000-0000-000000000000',
  name: 'English'
};
